module.exports = __webpack_public_path__ + "img/直播场景_电商直播.9bbb9ec6.png";